export { JobApplicationDetails } from './JobApplicationDetails';
